import { render, staticRenderFns } from "./ReestablecerClave.vue?vue&type=template&id=0decc974&scoped=true"
import script from "./ReestablecerClave.vue?vue&type=script&lang=js"
export * from "./ReestablecerClave.vue?vue&type=script&lang=js"
import style0 from "./ReestablecerClave.vue?vue&type=style&index=0&id=0decc974&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0decc974",
  null
  
)

export default component.exports